export const ADMIN_PANEL_PATH = "/aurum-vault-7391";
export const LIST_PANEL_PATH = "/lista-ops-vault-4829";
export const STOCK_PANEL_PATH = "/estoque-vault-2650";

export const isListPanelHost = () => {
  if (typeof window === "undefined") return false;
  const configuredHost = process.env.REACT_APP_LIST_PANEL_HOST;
  const host = window.location.hostname;
  return Boolean(
    (configuredHost && host === configuredHost) ||
    host.startsWith("lista."),
  );
};

export const isAdminPanelPath = (pathname) => (
  pathname === ADMIN_PANEL_PATH ||
  pathname === LIST_PANEL_PATH ||
  pathname === STOCK_PANEL_PATH ||
  isListPanelHost()
);

export const getAuthRedirectPath = () => {
  if (typeof window === "undefined") return "/";
  const currentPath = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  return isAdminPanelPath(window.location.pathname) ? currentPath : "/";
};
